export default "__VITE_PUBLIC_ASSET__9110d809__"